import { SHORTS_DETAILS_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Shorts } from 'core/models/Shorts';

const initialState: { spaceShort: Shorts | null, isLoading: boolean } = {
  spaceShort: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    spaceShort: Shorts;
  }
}

export default function shortsDetailsReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case SHORTS_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case SHORTS_DETAILS_ACTION.SUCCESS:
      const { spaceShort } = action.payload;
      return { ...state, spaceShort, isLoading: false }

    case SHORTS_DETAILS_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}